import { Component } from '@angular/core';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-version-display',
  templateUrl: './version-display.component.html',
  styleUrls: ['./version-display.component.scss']
})
export class VersionDisplayComponent 
{
  version: string;
  constructor() 
  {
    if ((packageJson) && (packageJson.version))
    {
      this.version = packageJson.version;
    }
    else
    {
      this.version = '0.0.0';
    }
  }
}
